import { Footer } from './Footer';
import {
	DialogSteps,
	Grid,
	Icon,
	Box,
	GridItem,
	Text,
	Stack,
	Alert,
} from '@welbe/design-system';
import { LuArrowRight, LuCake, LuMail, LuPhone } from 'react-icons/lu';
import { SectionIconText } from './SectionIconText';
import { FaRegAddressCard } from 'react-icons/fa';
import { LiaTransgenderSolid } from 'react-icons/lia';
import type { MergedStepComponentProps } from '../MergeEmployeesDialog.types';

export const ConfirmProfile = ({
	employees,
	primaryEmployeeId,
	onClose,
	onBack,
	onNext,
}: MergedStepComponentProps) => {
	const primary = employees.find((e) => e.id === primaryEmployeeId);

	return (
		<>
			<DialogSteps.Body>
				<Stack gap="2rem" pt="1rem">
					<Stack>
						<Text fontSize="sm" color="#64778F">
							El expediente unificado se guardará con la{' '}
							<strong>
								información personal correspondiente al perfil principal
								seleccionado.
							</strong>
						</Text>
						<Text fontSize="sm" color="#64778F">
							<strong>El perfil secundario quedará inactivo</strong> en el
							sistema, pero se mantendrá visible y no se podrán generar nuevas
							informaciones médicas asociadas con él
						</Text>
					</Stack>
					<Alert.Root status="error">
						<Alert.Indicator />
						<Alert.Content>
							<Alert.Title fontWeight="bold">
								Este cambio es permanente
							</Alert.Title>
							<Alert.Description>
								Asegurarte de elegir a los colaboradores correctos y al perfil
								principal antes de finalizar el proceso.
							</Alert.Description>
						</Alert.Content>
					</Alert.Root>
					<Grid
						gridTemplateColumns="1fr 20px 1.5fr"
						gap="2rem"
						px="1rem"
						alignItems="center"
					>
						<Box
							bg="gray.100"
							p="1.5rem"
							borderRadius="lg"
							gap="1rem"
							display="flex"
							flexDirection="column"
						>
							{employees.map((employee) => (
								<ItemBox key={employee.id}>{employee.name}</ItemBox>
							))}
						</Box>
						<Icon>
							<LuArrowRight size={20} />
						</Icon>
						<Box
							p="0.75rem 1rem"
							border="1px solid"
							borderColor="gray.200"
							borderRadius="lg"
							display="flex"
							flexDirection="column"
							gap="1rem"
						>
							<Text fontWeight="600" fontSize="sm" lineHeight="20px">
								{primary?.name}
							</Text>
							<Grid templateColumns="1fr 1fr" gap="0.5rem">
								<GridItem colSpan={2}>
									<SectionIconText
										icon={<FaRegAddressCard />}
										label={primary?.nationalIdentity || '-'}
									/>
								</GridItem>
								<SectionIconText
									icon={<LuCake />}
									label={primary?.birthDate || '-'}
								/>

								<SectionIconText
									icon={<LiaTransgenderSolid />}
									label={primary?.gender || '-'}
								/>

								<SectionIconText
									icon={<LuMail />}
									label={primary?.email || primary?.alternativeEmail || '-'}
								/>

								<SectionIconText
									icon={<LuPhone />}
									label={primary?.phone || primary?.alternativePhone || '-'}
								/>
							</Grid>
						</Box>
					</Grid>
				</Stack>
			</DialogSteps.Body>
			<Footer
				onClose={onClose}
				onBack={onBack}
				onNext={() => onNext(primaryEmployeeId)}
			/>
		</>
	);
};

const ItemBox = ({ children }: { children: React.ReactNode }) => {
	return (
		<Box
			p="0.75rem 1rem"
			bg="white"
			border="1px solid"
			borderColor="gray.200"
			borderRadius="lg"
			fontSize="sm"
			fontWeight="600"
			truncate
		>
			{children}
		</Box>
	);
};
